export const MOBILE_APP_STORE_VERSION = '1.1.45';

export const MOBILE_STORE_LINKS = {
  ios: 'https://apps.apple.com/br/app/clarity-files-app/id6770992838',
  android: 'https://play.google.com/store/apps/details?id=com.clarityfiles.app',
};

export const getPreferredMobileStoreTargets = (navigatorLike) => {
  const source = navigatorLike || (typeof navigator !== 'undefined' ? navigator : null);
  const userAgent = String(source?.userAgent || '');
  const platform = String(source?.platform || '');
  const maxTouchPoints = Number(source?.maxTouchPoints || 0);

  if (/android/i.test(userAgent)) return ['android'];
  if (/iphone|ipad|ipod/i.test(userAgent) || (/mac/i.test(platform) && maxTouchPoints > 1)) return ['ios'];
  return ['ios', 'android'];
};
